import { render, staticRenderFns } from "./SideNavBarQuestionLink.vue?vue&type=template&id=6cc6f2bc&scoped=true"
import script from "./SideNavBarQuestionLink.vue?vue&type=script&lang=js"
export * from "./SideNavBarQuestionLink.vue?vue&type=script&lang=js"
import style0 from "./SideNavBarQuestionLink.vue?vue&type=style&index=0&id=6cc6f2bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc6f2bc",
  null
  
)

export default component.exports